import React from 'react';
import { Provider } from 'react-redux';
import config from '@medflex/utils/config';
import createStore from '../store/createStore';
import AppWrapper from '../AppWrapper';
import PhysicianApp from './App';

import UserProfileRestrictedRoute from '../routes/UserProfileRestrictedRoute';
import * as models from './models';

const store = createStore({ models });
// eslint-disable-next-line no-underscore-dangle
if (config.DEBUG === '1') global.__store__ = store;

const PhysicianEntry = () => (
  <Provider store={store}>
    <AppWrapper desktopRedirectRoute="/desktop/arzt" mobileRedirectRoute="/mobile/arzt">
      <UserProfileRestrictedRoute component={PhysicianApp} />
    </AppWrapper>
  </Provider>
);

export default PhysicianEntry;
